import React, { useEffect, useRef, useState } from "react"

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src?: string
  alt?: string
  fallbackSrc?: string
}

export function Image({
  className,
  src,
  alt = "",
  fallbackSrc = "/favicon-96x96.png",
  ...props
}: ImageProps) {
  const [imgSrc, setImgSrc] = useState<string>(src || fallbackSrc)
  const [hasError, setHasError] = useState(false)
  const prevSrcRef = useRef(src)

  const handleError = () => {
    // Prevent infinite loop if fallback also fails
    if (!hasError && imgSrc !== fallbackSrc) {
      setHasError(true)
      setImgSrc(fallbackSrc)
    }
  }

  // Update imgSrc when src prop changes
  useEffect(() => {
    // If src changed to a new value, reset error state and try again
    if (src && src !== prevSrcRef.current) {
      prevSrcRef.current = src
      setHasError(false)
      setImgSrc(src)
    } else if (src && src !== imgSrc && !hasError) {
      setImgSrc(src)
    }
  }, [src, imgSrc, hasError])

  return <img src={imgSrc} alt={alt} onError={handleError} className={className} {...props} />
}
